import { render, staticRenderFns } from "./CmgUnsupportedBrowser.vue?vue&type=template&id=0956f001&scoped=true&lang=pug&"
import script from "./cmg-unsupported-browser.ts?vue&type=script&lang=ts&"
export * from "./cmg-unsupported-browser.ts?vue&type=script&lang=ts&"
import style0 from "./CmgUnsupportedBrowser.vue?vue&type=style&index=0&id=0956f001&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0956f001",
  null
  
)

export default component.exports